import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApartmentsComponent } from './apartments.component';
import { ImgHeaderModule } from '../../img-header/img-header.module';
import { Angular2ImageGalleryModule } from 'angular2-image-gallery/app/angular2imagegallery.module';
import { SharedModule } from '../../shared/shared.module';
import { ApartmentOneModule } from '../apartment-one/apartment-one.module';
import { ApartmentTwoModule } from '../apartment-two/apartment-two.module';
import { ApartmentThreeModule } from '../apartment-three/apartment-three.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    ImgHeaderModule,
    Angular2ImageGalleryModule,
    SharedModule,
    ApartmentOneModule,
    ApartmentTwoModule,
    ApartmentThreeModule,
    RouterModule
  ],
  declarations: [
    ApartmentsComponent
  ]
})
export class ApartmentsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/apartments/apartments.module.ts